import { FormRichTextEditor } from '@exam-management/rich-text-editor';

import { BaseItemSetParagraphSection } from '../../components';
import { useUploadImageForQuestion } from '../../hooks';

export default function ItemSetCreationParagraphSection() {
  const { handleUpload, loading: isLoading } = useUploadImageForQuestion();

  return (
    <BaseItemSetParagraphSection>
      <FormRichTextEditor
        placeholder='กรอกบทความที่นี่'
        name='details.paragraph'
        rows={2}
        onImageUpload={handleUpload}
        loading={isLoading}
      />
    </BaseItemSetParagraphSection>
  );
}
